import { ErrorReason, ErrorStatus } from '@tink/core/src/tinkLinkErrorCodes';
import { applicationParameters } from './application-parameters';

export const isIframeMode = (isIframe: boolean = applicationParameters.get('isIframe')) => {
  return window.top !== window && isIframe;
};

export const isRedirectMode = () => {
  return !isIframeMode();
};

export const invalidCredentialsStateError = {
  errorStatus: ErrorStatus.BAD_REQUEST,
  errorReason: ErrorReason.INVALID_STATE_CREDENTIALS_IS_AWAITING_THIRD_PARTY,
};
